import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Link di ritorno in cima alle pagine di servizio del supporto (guida, base di
 * conoscenza, preferenze email), sia nel Centro Ticket admin sia nell'area
 * rappresentante: senza, l'unico ritorno era la sidebar (o il breadcrumb, che
 * nell'admin sparisce sotto i 1250px).
 */
interface SupportBackLinkProps {
  to: string;
  label: string;
}

const SupportBackLink: React.FC<SupportBackLinkProps> = ({ to, label }) => (
  <div className="mb-3">
    <Link
      to={to}
      className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 dark:text-primary-400 hover:underline"
    >
      <ArrowLeft size={13} aria-hidden="true" />
      {label}
    </Link>
  </div>
);

export default SupportBackLink;
